import React, { useContext, useState } from "react";
import { exportToXLSX } from "./exportUtils"; // Assuming exportToXLSX function is defined in a separate file
import AuthContext from "../../context/auth/authContext";
import setAuthToken from "../../functions/auth_header";
import { getAppUrl } from "../../functions/getEnv";
import axios from "axios";
import { toast } from "react-toastify";

const ExportButton = ({ data, getCurrentFilters, onExportStart, onExportComplete }) => {
  const authContext = useContext(AuthContext);
  const { user } = authContext;
  const appUrl = getAppUrl(import.meta.env.VITE_NODE_ENV);
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async () => {
    try {
      setIsExporting(true);
      if (onExportStart) onExportStart();

      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }

      // Fetch all records from backend with current filters
      const filters = getCurrentFilters ? getCurrentFilters() : {};
      const params = new URLSearchParams();

      // Add filters
      if (filters.charterName && filters.charterName !== "all") {
        params.append("learningCenterCharter", filters.charterName);
      }
      if (filters.learningCenterName && filters.learningCenterName !== "all") {
        params.append("learningCenterName", filters.learningCenterName);
      }
      if (filters.status && filters.status !== "all") {
        params.append("status", filters.status);
      }
      if (filters.age && filters.age !== "all") {
        params.append("age", filters.age);
      }
      if (filters.searchText && filters.searchText.trim() !== "") {
        params.append("search", filters.searchText.trim());
      }
      if (filters.startDate) {
        params.append("startDate", filters.startDate);
      }
      if (filters.endDate) {
        params.append("endDate", filters.endDate);
      }

      // Fetch ALL records (no pagination limit)
      params.append("page", 1);
      params.append("pageSize", 999999); // Large number to get all records

      const apiUrl = `${appUrl}/api/registration?${params.toString()}`;

      const response = await axios.get(apiUrl);
      const allData = response.data.data || response.data.regularRegistrations || [];


      // Export all data to Excel
      exportToXLSX(allData, "registration_data.xlsx");

      // Log the export
      await axios.post(`${appUrl}/api/dataexport`, {
        user_name: user?.name,
        azure_id: user?.azureID,
        fileName: "registration_data.xlsx",
        recordCount: allData.length,
        screen: "Primary Enrollments Admin Screen ",
        exportType: "excel",
        exportStatus: "success",
      });
      toast.success("Export completed successfully");
   
    } catch (error) {
      console.error("Error during export:", error);
      toast.error("An error occurred during export");
    } finally {
      setIsExporting(false);
      if (onExportComplete) onExportComplete();
    }
  };

  return (
    <button
      className="btn btn-llac-dark-grey"
      onClick={handleExport}
      disabled={isExporting}
      style={{
        fontSize: "15px",
        padding: "10px 25px",
        height: "46px",
        cursor: isExporting ? "not-allowed" : "pointer",
        opacity: isExporting ? 0.7 : 1,
        backgroundColor: isExporting ? "#6c757d" : "#537131", // Green background
        color: "white",
        border: "none",
        borderRadius: "4px",
        fontWeight: "500",
        transition: "all 0.2s ease-in-out",
      }}
    >
      {isExporting ? "Exporting..." : "Export to Excel"}
    </button>
  );
};

export default ExportButton;
